import { Component } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { FormlyFieldConfig } from "@ngx-formly/core";
import * as crypto from "crypto-js";
import { UserService } from "../../../services/user.service";

@Component({
        standalone: false,
    selector: "password",
    templateUrl: "./password.component.html",
})
export class AccountPassword {
    form: FormGroup;
    entity: any = {};
    fields: Array<FormlyFieldConfig> = [];

    constructor(
        private userService: UserService,
        formBuilder: FormBuilder,
        private router: Router,
        private route: ActivatedRoute
    ) {
        this.form = formBuilder.group({});

        this.fields = [
            {
                fieldGroup: [
                    {
                        className: "col-12",
                        key: "oldPassword",
                        type: "hz-input",
                        props: {
                            type: "password",
                            label: "Old Password",
                            placeholder: "********",
                            required: true,
                        },
                    },
                    {
                        className: "col-12",
                        key: "newPassword",
                        type: "hz-input",
                        props: {
                            type: "password",
                            label: "New Password",
                            placeholder: "********",
                            required: true,
                        },
                    },
                    {
                        className: "col-12",
                        key: "newPassword2",
                        type: "hz-input",
                        props: {
                            type: "password",
                            label: "Confirm Password",
                            placeholder: "********",
                            required: true,
                        },
                    },
                ],
            },
        ];

        this.entity = {};
    }

    submit() {
        if (this.form.valid) {
            if (
                !this.entity.newPassword ||
                this.entity.newPassword.length < 8
            ) {
                alert("Password must be 8 or more characters");
                return;
            }

            if (
                !/^(?=.*[a-z])(?=.*[A-Z])(?=.*[^\w])(?=.*[0-9]).{8,}$/.test(
                    this.entity.newPassword
                )
            ) {
                alert(
                    "Password must contain one or more upper case, lower case, number and symbols"
                );
                return;
            }

            if (/\s/.test(this.entity.newPassword)) {
                alert("Please ensure your password has no spaces.");
                return;
            }

            if (this.entity.newPassword == this.entity.newPassword2) {
                this.userService
                    .resetPassword(
                        crypto.SHA512(this.entity.oldPassword).toString(),
                        crypto.SHA512(this.entity.newPassword).toString()
                    )
                    .subscribe(
                        (data) => {
                            this.userService.getUser().subscribe(
                                (data) => this.userService.setUser(data),
                                null,
                                () => {
                                    this.router.navigate(["../..", "home"], {
                                        relativeTo: this.route,
                                    });
                                }
                            );
                        },
                        (err) => alert(err)
                    );
            } else {
                alert("Passwords don't match");
            }
        } else {
            alert("All fields are mandatory");
        }
    }
}
